var option_webview_default = {
  "option": "-yadx",
  "user_choice": "_6T4nZ",
  "check": "ZzwSt",
  "image": "_1TdKJ",
  "input": "qLuoc",
  "title": "fMc9Y",
  "centered": "TrSSf",
  "with_result": "PKzou",
  "list": "Q3Qsj",
  "with_image": "MGfK3",
  "progress": "jNryj",
  "progress_value": "SbtWz",
  "label": "_00fzr",
  "cta": "OKosp",
  "adornment_icon": "tbPH3",
  "remove": "Jzqn1",
  "removeButton": "-FUT4",
  "removeButtonIcon": "FaE4R",
  "overlay": "lPU3h",
  "shown": "jvLop",
  "dark": "T9k4Z",
  "spinner": "DTM7w",
  "spin": "Otq7H",
  "grid": "_86ZCj"
};
export {
  option_webview_default as default
};
//# sourceMappingURL=option-webview-scss.js.map
